const styleGuideNav = function () {
	let dropdowns, mainMenu, mobileMenuBtn, menuArea, mobileHdr

	initializeVariables = () => {
		dropdowns = document.getElementsByClassName("dropdown-toggle");
		mainMenu = document.querySelector(".mainMenu");
		mobileMenuBtn = document.getElementById("mobileBtn");
		menuArea = document.querySelector(".sgMenu");
		mobileHdr = document.querySelector(".mobileMenuHeader");
	},
	init = () => {
		initializeVariables();
		menuArea.addEventListener("click", menuEvents);
		menuArea.addEventListener("keyup", menuKeyEvents);
		document.addEventListener("click", detectOutsideClick);
	},
	menuEvents = e => {
		if (e.target.classList.contains("dropdown-toggle")) {
			e.preventDefault();
			let el = e.target;
			toggleSubMenu(el);
		} else if (e.target.id == "mobileBtn") {
			e.preventDefault();
			toggleMobileMenu();
		}
	},
	menuKeyEvents = e => {
		if (e.keyCode == 27) closeOpenSubMenu();
	},
	toggleSubMenu = trigger => {
		if (trigger.parentNode.classList.contains("openMenu"))
			closeOpenSubMenu();
		else
			openSubMenu(trigger);
	},
	toggleMobileMenu = () => {
		if (mobileMenuBtn.getAttribute("aria-expanded") == "false")
			openMobileMenu();
		else
			closeMobileMenu();
	},
	openMobileMenu = () => {
		closeOpenSubMenu();
		mainMenu.style.display = "block";
		mobileHdr.classList.remove("hide");
		mobileMenuBtn.setAttribute("aria-expanded", "true");
	},
	closeMobileMenu = () => {
		closeOpenSubMenu();
		mobileHdr.classList.add("hide");
		mainMenu.removeAttribute("style");
		mobileMenuBtn.setAttribute("aria-expanded", "false");
		mobileMenuBtn.focus();
	},
	detectOutsideClick = e => {
		if (!mainMenu.contains(e.target) && document.querySelector(".openMenu"))
			closeOpenSubMenu();
	},
	closeOpenSubMenu = () => {
		if (document.querySelector(".openMenu")) {
			let openMenu = document.querySelector(".openMenu");
			openMenu.querySelector("button").setAttribute("aria-expanded", "false");
			openMenu.querySelector("svg").classList.add("rotate180");
			openMenu.querySelector(".dropdown-menu").classList.remove("animateFadeIn");
			openMenu.querySelector(".dropdown-menu").classList.add("animateFadeOut");
			setTimeout(() => {
				openMenu.querySelector(".dropdown-menu").classList.add("hide");
				openMenu.classList.remove("openMenu");
			}, 250);
		}
	},
	openSubMenu = trigger => {
		closeOpenSubMenu();
		trigger.parentNode.classList.add("openMenu");
		trigger.setAttribute("aria-expanded", "true");
		trigger.querySelector("svg").classList.remove("rotate180");
		if(!trigger.nextElementSibling.classList.contains("animateFadeIn")) trigger.nextElementSibling.classList.add("animateFadeIn");
		trigger.nextElementSibling.classList.remove("animateFadeOut");
		trigger.nextElementSibling.classList.remove("hide");
	};

	return {
		Init: init
	};
};

(function () {
	const styleNavigation = new styleGuideNav();
	styleNavigation.Init();
})();